<div class="page">
  <img class="scanner" src="./assets/img/scanner.png">
  <p class="error">500</p>
  <p>{{ 'internal_server_error' | translate }}</p>
  <button class="button" (click)="location.back()">{{ 'go_back' | translate }}</button>
  <img class="img-fluid nimmsta-logo" src="./assets/img/logo.webp">
</div>
